import React from 'react';
import { CodeBlock } from '@/components/docs/CodeBlock';

export default function AuthPage() {
  return (
    <article className="max-w-3xl" data-testid="docs-auth">
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mb-4">Authentication</h1>
      <p className="text-base text-white/50 leading-relaxed mb-8">Handle protected pages during CLI bone extraction.</p>

      <h2 className="text-xl font-bold tracking-tight mb-4">Option 1: Fixture prop (recommended)</h2>
      <p className="text-sm text-white/40 mb-4 leading-relaxed">The simplest approach. Provide mock data so the CLI can capture bones without auth:</p>
      <CodeBlock filename="dashboard/page.tsx" code={`<Skeleton
  name="dashboard"
  loading={isLoading}
  fixture={<Dashboard data={mockData} />}
>
  {data && <Dashboard data={data} />}
</Skeleton>`} />

      <h2 className="text-xl font-bold tracking-tight mb-4 mt-10">Option 2: Config file with cookies/headers</h2>
      <p className="text-sm text-white/40 mb-4 leading-relaxed">Add auth to <code className="text-white/60 bg-white/[0.06] px-1.5 py-0.5 rounded text-xs">ghostlayout.config.json</code>:</p>
      <CodeBlock filename="ghostlayout.config.json" language="json" code={`{
  "resolveEnvVars": true,
  "auth": {
    "cookies": [
      {
        "name": "session",
        "value": "env[SESSION_TOKEN]"
      }
    ],
    "headers": {
      "Authorization": "Bearer env[API_TOKEN]"
    }
  }
}`} />
      <p className="text-sm text-white/40 mt-4 mb-4 leading-relaxed">Then set environment variables before running:</p>
      <CodeBlock language="bash" code={`SESSION_TOKEN=abc123 API_TOKEN=xyz789 npx ghostlayout build`} />

      <div className="border border-white/[0.06] bg-[#0A0A0A] rounded-lg p-5 mt-6 mb-8">
        <p className="text-sm text-white/40"><strong className="text-white/60">env[VAR]</strong> placeholders are replaced with actual environment variable values when <code className="text-white/60 bg-white/[0.06] px-1 py-0.5 rounded text-xs">resolveEnvVars</code> is true. This keeps secrets out of your config file.</p>
      </div>

      <h2 className="text-xl font-bold tracking-tight mb-4">Option 3: Disable auth in dev</h2>
      <p className="text-sm text-white/40 mb-4 leading-relaxed">Run your dev server with auth bypassed:</p>
      <CodeBlock language="bash" code={`AUTH_DISABLED=true npm run dev\nnpx ghostlayout build`} />
    </article>
  );
}
